export const PAYMENT_ALERT_HEADER_TITLE_ID = "payment-alert-header-title";
export const PAYMENT_ALERT_CONTENT_ID = "payment-alert-content";
